import React, { RefObject } from 'react';
import { Row, Col } from 'react-bootstrap';
import $ from 'jquery';

type State = {
  showContent: boolean;
  showLoading: boolean;
  isDone: boolean;
  isClose: boolean;
  url: string;
  bars: JSX.Element[];
};

export default class LoadingComponent extends React.Component<unknown, State> {
  private rowClass: RefObject<HTMLDivElement>;

  constructor(props: unknown) {
    super(props);
    const kaz = (
      <div>
        <div>K</div>
        <div>A</div>
        <div>Z</div>
      </div>
    );
    this.state = {
      showContent: true,
      showLoading: true,
      isDone: false,
      bars: [kaz],
      url: '/',
      isClose: false
    };
    this.rowClass = React.createRef();
  }

  setBars(bars: JSX.Element[]) {
    this.setState({ bars });
  }

  componentDidMount() {
    this.setState({ isDone: true });
  }

  scrollAndLoadAnimation(url: string) {
    this.setState({ url });
    const m = () => {
      const y = window.scrollY;
      if (y == 0) {
        this.loadAnimation();
        $(document).off('scroll', m);
      }
    };
    if (window.scrollY == 0) {
      this.loadAnimation();
    } else {
      window.scroll({ top: 0 });
      $(document).on('scroll', m);
    }
  }

  closeAnimation() {
    this.setState({ isClose: true });
    const elements = this.rowClass.current?.children;
    setTimeout(() => {
      if (!elements) return;
      $('body').removeClass('overflow-hidden');
      $(elements).css('height', '0%');
      this.rowClass.current?.classList.add('d-none');
    }, 1500);
  }

  loadAnimation() {
    this.setState({ isDone: false, isClose: false });
    const time = 5;
    this.rowClass.current?.classList.remove('d-none');
    function addNewItem(id: number, height = 0) {
      return { id: setInterval(() => frame(id), time), height };
    }

    const elements = this.rowClass.current?.children;

    if (elements) $(elements).css('height', '0%');
    type BarType = { [index: number]: { id: NodeJS.Timeout; height: number } };
    const bars: BarType = {
      0: addNewItem(0)
    };
    const deltaTime = 30;

    const frame = (index: number) => {
      let height = bars[index].height;
      if (index >= this.state.bars.length) {
        clearInterval(bars[index].id);
        return;
      }
      if (height == deltaTime) {
        bars[index + 1] = addNewItem(index + 1);
      }
      if (height == 101) {
        clearInterval(bars[index].id);
        if (index == this.state.bars.length - 1) {
          this.setState({ isDone: true });
        }
      } else {
        height++;
        if (!elements) return;
        const element = elements.item(index);
        if (!element) return;
        bars[index] = { ...bars[index], height };
        $(element).css('height', height.toString() + '%');
      }
    };
  }

  render() {
    return (
      <>
        <Row
          className={`loading ${this.state.isDone ? 'show' : 'align-items-end'} ${
            this.state.isClose ? 'closed' : ''
          }`}
          ref={this.rowClass}
        >
          {this.state.bars.map((bar, index) => (
            <Col
              key={`bar${index}-${this.state.url.replace('/', '-')}`}
              style={{ height: '100%' }}
              className={
                'bar-item ' +
                (this.state.showContent ? 'hide ' : ' ') +
                (index + 1 == Math.round(this.state.bars.length / 2) || this.state.bars.length == 1
                  ? 'middle'
                  : '') +
                (this.state.isDone ? ' show' : '')
              }
            >
              <span className="item">{bar}</span>
            </Col>
          ))}
        </Row>
      </>
    );
  }
}
